/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  MicrosoftAspNetCoreMvcProblemDetails,
  TrainWithMeModulesSubscriptionsDtosRequestsPostWebCheckoutRequest,
  TrainWithMeModulesSubscriptionsDtosRequestsPostWebCheckoutReturnRequest,
  TrainWithMeModulesSubscriptionsDtosResponsesWebCheckoutReturnResponse,
  TrainWithMeModulesSubscriptionsDtosResponsesWebCheckoutUrlResponse,
  TrainWithMeModulesSubscriptionsDtosResponsesWebTrialResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const postMeSubscriptionWebCheckout = (
    trainWithMeModulesSubscriptionsDtosRequestsPostWebCheckoutRequest?: BodyType<TrainWithMeModulesSubscriptionsDtosRequestsPostWebCheckoutRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSubscriptionsDtosResponsesWebCheckoutUrlResponse>(
      {url: `/me/subscription/web/checkout`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesSubscriptionsDtosRequestsPostWebCheckoutRequest, signal
    },
      options);
    }




export const getPostMeSubscriptionWebCheckoutMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMeSubscriptionWebCheckout>>, TError,{data?: BodyType<TrainWithMeModulesSubscriptionsDtosRequestsPostWebCheckoutRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postMeSubscriptionWebCheckout>>, TError,{data?: BodyType<TrainWithMeModulesSubscriptionsDtosRequestsPostWebCheckoutRequest>}, TContext> => {

const mutationKey = ['postMeSubscriptionWebCheckout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMeSubscriptionWebCheckout>>, {data?: BodyType<TrainWithMeModulesSubscriptionsDtosRequestsPostWebCheckoutRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postMeSubscriptionWebCheckout(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostMeSubscriptionWebCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof postMeSubscriptionWebCheckout>>>
    export type PostMeSubscriptionWebCheckoutMutationBody = BodyType<TrainWithMeModulesSubscriptionsDtosRequestsPostWebCheckoutRequest> | undefined
    export type PostMeSubscriptionWebCheckoutMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostMeSubscriptionWebCheckout = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMeSubscriptionWebCheckout>>, TError,{data?: BodyType<TrainWithMeModulesSubscriptionsDtosRequestsPostWebCheckoutRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMeSubscriptionWebCheckout>>,
        TError,
        {data?: BodyType<TrainWithMeModulesSubscriptionsDtosRequestsPostWebCheckoutRequest>},
        TContext
      > => {
      return useMutation(getPostMeSubscriptionWebCheckoutMutationOptions(options), queryClient);
    }
    export const postMeSubscriptionWebCheckoutReturn = (
    trainWithMeModulesSubscriptionsDtosRequestsPostWebCheckoutReturnRequest?: BodyType<TrainWithMeModulesSubscriptionsDtosRequestsPostWebCheckoutReturnRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSubscriptionsDtosResponsesWebCheckoutReturnResponse>(
      {url: `/me/subscription/web/checkout/return`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesSubscriptionsDtosRequestsPostWebCheckoutReturnRequest, signal
    },
      options);
    }




export const getPostMeSubscriptionWebCheckoutReturnMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMeSubscriptionWebCheckoutReturn>>, TError,{data?: BodyType<TrainWithMeModulesSubscriptionsDtosRequestsPostWebCheckoutReturnRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postMeSubscriptionWebCheckoutReturn>>, TError,{data?: BodyType<TrainWithMeModulesSubscriptionsDtosRequestsPostWebCheckoutReturnRequest>}, TContext> => {

const mutationKey = ['postMeSubscriptionWebCheckoutReturn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMeSubscriptionWebCheckoutReturn>>, {data?: BodyType<TrainWithMeModulesSubscriptionsDtosRequestsPostWebCheckoutReturnRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postMeSubscriptionWebCheckoutReturn(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostMeSubscriptionWebCheckoutReturnMutationResult = NonNullable<Awaited<ReturnType<typeof postMeSubscriptionWebCheckoutReturn>>>
    export type PostMeSubscriptionWebCheckoutReturnMutationBody = BodyType<TrainWithMeModulesSubscriptionsDtosRequestsPostWebCheckoutReturnRequest> | undefined
    export type PostMeSubscriptionWebCheckoutReturnMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostMeSubscriptionWebCheckoutReturn = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMeSubscriptionWebCheckoutReturn>>, TError,{data?: BodyType<TrainWithMeModulesSubscriptionsDtosRequestsPostWebCheckoutReturnRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMeSubscriptionWebCheckoutReturn>>,
        TError,
        {data?: BodyType<TrainWithMeModulesSubscriptionsDtosRequestsPostWebCheckoutReturnRequest>},
        TContext
      > => {
      return useMutation(getPostMeSubscriptionWebCheckoutReturnMutationOptions(options), queryClient);
    }
    export const postMeSubscriptionWebPortal = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSubscriptionsDtosResponsesWebCheckoutUrlResponse>(
      {url: `/me/subscription/web/portal`, method: 'POST', signal
    },
      options);
    }




export const getPostMeSubscriptionWebPortalMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMeSubscriptionWebPortal>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postMeSubscriptionWebPortal>>, TError,void, TContext> => {

const mutationKey = ['postMeSubscriptionWebPortal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMeSubscriptionWebPortal>>, void> = () => {


          return  postMeSubscriptionWebPortal(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostMeSubscriptionWebPortalMutationResult = NonNullable<Awaited<ReturnType<typeof postMeSubscriptionWebPortal>>>

    export type PostMeSubscriptionWebPortalMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostMeSubscriptionWebPortal = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMeSubscriptionWebPortal>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMeSubscriptionWebPortal>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPostMeSubscriptionWebPortalMutationOptions(options), queryClient);
    }
    export const getMeSubscriptionWebTrial = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSubscriptionsDtosResponsesWebTrialResponse>(
      {url: `/me/subscription/web/trial`, method: 'GET', signal
    },
      options);
    }




export const getGetMeSubscriptionWebTrialQueryKey = () => {
    return [
    `/me/subscription/web/trial`
    ] as const;
    }


export const getGetMeSubscriptionWebTrialQueryOptions = <TData = Awaited<ReturnType<typeof getMeSubscriptionWebTrial>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeSubscriptionWebTrial>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeSubscriptionWebTrialQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeSubscriptionWebTrial>>> = ({ signal }) => getMeSubscriptionWebTrial(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMeSubscriptionWebTrial>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeSubscriptionWebTrialQueryResult = NonNullable<Awaited<ReturnType<typeof getMeSubscriptionWebTrial>>>
export type GetMeSubscriptionWebTrialQueryError = ErrorType<unknown>


export function useGetMeSubscriptionWebTrial<TData = Awaited<ReturnType<typeof getMeSubscriptionWebTrial>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeSubscriptionWebTrial>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeSubscriptionWebTrial>>,
          TError,
          Awaited<ReturnType<typeof getMeSubscriptionWebTrial>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeSubscriptionWebTrial<TData = Awaited<ReturnType<typeof getMeSubscriptionWebTrial>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeSubscriptionWebTrial>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeSubscriptionWebTrial>>,
          TError,
          Awaited<ReturnType<typeof getMeSubscriptionWebTrial>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeSubscriptionWebTrial<TData = Awaited<ReturnType<typeof getMeSubscriptionWebTrial>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeSubscriptionWebTrial>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMeSubscriptionWebTrial<TData = Awaited<ReturnType<typeof getMeSubscriptionWebTrial>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeSubscriptionWebTrial>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeSubscriptionWebTrialQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






